<div class="page-header-outer">
    <div class="page-header">
        <h1>
         <span class="icon-check-circle warning success workflow-green-check"></span>   {{ getWorkflowCompletedUserName()  }}, Thank you for completing your staffing plan for the {{formattedShiftBlockRange()}} block for
            {{costCenter.name}} {{costCenter.number}}
        </h1>
        <br>
        <br>

        <div class="button-center">
            <button [routerLink]="listCostCenters"> View Cost Centers </button>
            <ng-template [ngIf]="shiftBlock"> <button [routerLink]="listShiftBlocks"> View Shift Blocks </button>
            </ng-template>
        </div>
    </div>
       
</div> 
